export default "__VITE_ASSET__BXsBAus3__"